module.exports = __webpack_public_path__ + "static_pc/img/10.b8382540.png";